import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { HushedFrame } from '../screens/auth/HushedFrame';
import { ResetPasswordPage } from '../screens/auth/ResetPasswordPage';

const searchSchema = z.object({
  /** The token from the mailed link; anything else reads as an expired link. */
  t: z.string().min(1).max(128).catch(''),
});

/**
 * The page the forgotten-password mail links to (`PasswordResetEmail.Page` in the API). No sign-in:
 * the link's token is the credential, and it can only set that account's password, once.
 */
export const Route = createFileRoute('/reset-password')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = Route.useSearch();
  return <ResetPasswordPage token={t} Frame={HushedFrame} />;
}
